var render, staticRenderFns
import script from "./popup-state.vue?vue&type=script&lang=ts&"
export * from "./popup-state.vue?vue&type=script&lang=ts&"
import style0 from "./popup-state.vue?vue&type=style&index=0&id=672c906c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c906c",
  null
  
)

export default component.exports